
import { useNavigate } from "react-router-dom";
import right from "@/image/right.svg";
import { useTranslation } from "react-i18next";
import friendImg from "@/image/friendImg.svg";
import hashImg from "@/image/hashImg.svg";
import gradeImg from "@/image/gradeImg.svg";
import myLinkImg from "@/image/myLinkImg.svg";
import messageImg from "@/image/messageImg.svg";
import bridgeSvg from "@/image/bridgeSvg.svg";
const My = () => {
    const { t } = useTranslation()
    // 初始化路由
    const navigate = useNavigate();

    // pageDate
    const pageDate = [
        {
            title: t('my.inviteFriends'),
            img: friendImg,
            link: '/invite',
            href: false
        }, {
            title: t('my.miningPool'),
            img: hashImg,
            link: '/powerPool',
            href: false

        }, {
            title: t('my.currentLevel'),
            img: gradeImg,
            link: '/grade',
            href: false
        }, {
            title: t('my.myLinks'),
            img: myLinkImg,
            link: '/myLink',
            href: false
        }, {
            title: t('my.publishNews'),
            img: messageImg,
            link: '/information',
            href: false
        },
        {
            title: t('my.bridge'),
            img: bridgeSvg,
            link: '/bridge',
            href: false
        },
    ]
    return (

        <div className="mx-4 mt-8 md:max-w-[750px] md:mx-auto md:pt-12 md:mt-0">
            {pageDate.map((item, index) => {
                return <div onClick={() => {
                    item.href ? window.location.href = item.link : navigate(item.link)
                }} key={index} className="cursor-pointer px-4.5 py-5 md:px-6 md:py-6 rounded-md flex justify-between items-center bg-3c mb-2.5 md:mb-4 hover:opacity-90 transition-opacity">
                    <div className="flex items-center">
                        <img className="w-4.5 h-4.5 md:w-6 md:h-6 mr-2 md:mr-3" src={item.img} alt="" />
                        <span className="text-sm md:text-base text-white">{item.title}</span>
                    </div>
                    <img className="w-4 h-4 md:w-5 md:h-5" src={right} alt="" />
                </div>
            })}
        </div>
    );
};

export default My;
